<clr-checkbox-wrapper>
    <input
        type="checkbox"
        clrCheckbox
        [formControl]="formControl"
        [vdrDisabled]="!!readonly"
    />
</clr-checkbox-wrapper>
